import { render, staticRenderFns } from "./policy.vue?vue&type=template&id=4e026deb&scoped=true&"
import script from "./policy.vue?vue&type=script&lang=js&"
export * from "./policy.vue?vue&type=script&lang=js&"
import style0 from "./policy.vue?vue&type=style&index=0&id=4e026deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e026deb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e026deb')) {
      api.createRecord('4e026deb', component.options)
    } else {
      api.reload('4e026deb', component.options)
    }
    module.hot.accept("./policy.vue?vue&type=template&id=4e026deb&scoped=true&", function () {
      api.rerender('4e026deb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/policy.vue"
export default component.exports